module.exports = __webpack_public_path__ + "img/21.e5096537.webp";